import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ChangeNavbar } from '../actions';
import YouTube from 'react-youtube';

import './Header.css';
import './HeaderYoutube.css'

class HeaderYoutube extends Component {
  constructor(props) {
    super(props);
    this.props.SetHeaderNavbar(true);
    this.state = {
      videoOptions: {
        playerVars: { // https://developers.google.com/youtube/player_parameters
          autoplay: 1,
          mute: 1,
          modestbranding: 1,
          autohide: 1,
          showinfo: 0,
          controls: 0,
          disablekb: 1,
          rel: 0,
          fs: 0,
          start: this.props.start_time,
          end: this.props.end_time
        }
      }
    };
  }

  youtube_onPlay(event) {
    //event.target.mute();
  }

  youtube_onEnd(event) {
    event.target.playVideo();
    //event.target.seekTo(6);
  }

  render() {
    return (
      <header className={"masthead " + this.props.className + " text-center text-white d-flex"}>
        {this.props.header_content(this.props.header_parameters)}
        <div className="video-background">
          <YouTube
          containerClassName="video-foreground"
          className="video-iframe"
          videoId={this.props.video_id}
          opts={this.state.videoOptions}
          onPlay={this.youtube_onPlay}
          onEnd={this.youtube_onEnd}
          />
        </div>
      </header>
      );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetHeaderNavbar: (haveHeader) => {dispatch(ChangeNavbar(haveHeader))}
  }
}

function mapStateToProps(state) {
  return {  }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(HeaderYoutube);
